
import {
  Avatar,
  Chip,
  TableCell,
  TableRow
} from '@mui/material';
import { DateTime } from 'luxon';

import React from 'react';
import { useNavigate } from 'react-router-dom';



export type PersonTableRowProps = {
  id: string;
  fullName: string;
  createdDate: DateTime;
  profileUrl: string;
  phoneNumber: string;
  email: string;
  isActive: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PersonTableRowProps) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`${props.id}`);
  };

  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
        handleNavigate();
      }}
    >
      <TableCell
        variant='firstRounded'
      >
        <Avatar
          src={props.profileUrl}
        />
        {props.fullName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.createdDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.phoneNumber}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.email}
      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        {props.isActive
          ? (
            <Chip
              variant='inProgressBlue'
              label='Member'
            />
          )
          : (
            <Chip
              variant='inProgressBlue'
              label='Member'
            />
          )}
      </TableCell>

    </TableRow>

  );
};
